import axios from "axios";
import state from "../store";

const baseURL = state.getters.mainAppURL + "users/";
const getAllUsers = () => axios.get(baseURL + "get_all_users_full_name");

export {
    getAllUsers
}